import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'
import Searchbar from './Searchbar';



const Navbar = ({cartItem}) => {
  const [open, setState] = useState(false);

  return (
    <>
         
          <button className="menu" onClick={() => setState(!open)}>
            <svg width="40" height="40" viewBox="0 0 100 100">
              <path className={open ? "line lineCode1" : "line line1"} d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
              <path className={open ? "line lineCode2" : "line line2"} d="M 20,50 H 80" />
              <path className={open ? "line lineCode3" : "line line3"} d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
            </svg>
          </button>
          {/* Menulist */}

          <div className={open ? "MobileContainer" : "DesktopContainer"} >
            <div className={open ? "ForLeftMobile" : "ForLeft"}>
              <span>CartZet</span>
              <span className='LogoForMobile'>KTechweb</span>
            </div>
            <div className={open ? "Mobilemenu" : "Desktopmenu"}>
              <NavLink to="/" className="navLink Nlink"  style={{ textDecoration: 'none' }}   >
                <i class="fas fa-home"></i>Home
              </NavLink>
              <NavLink to="/Signup" className="navLink Nlink" style={{ textDecoration: 'none' }}   >
                <i class="fab fa-magento"></i> Signup
              </NavLink>
              
              
                    <NavLink to="/Cart" className="navLink Nlink" style={{ textDecoration: 'none' }}>
                      <i class="fas fa-shopping-cart"></i>
                   <sup><span className='cart-count'>
                       {cartItem.length===0 ? "":cartItem.length}
                   </span></sup>
                   </NavLink>
                
            </div>
            
          </div>
       
           
        </>
  )
}

export default Navbar
